<template>
	<div class='main_div'>
		 <div class="container">
            <div style="display: inline-block; height:40px;">
                <el-button type="warning" @click="setAdd()">添加</el-button>
            </div>
            <div style="display: inline-block; height:40px;">
                <el-button type="primary" @click="getData()">刷新</el-button>
            </div>
            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="roleId"
                height="350"
                v-loading="loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                element-loading-text = "数据正在加载中..."
                border fit highlight-current-row>
                <el-table-column type="index" label="序号" width="50" :index="indexMethod"></el-table-column>
                <el-table-column prop="title" label="指标名称" width="130"></el-table-column>
                <el-table-column prop="evaluateTypeName" label="五育类型" width="130"></el-table-column>
                <el-table-column prop="" label="初始分数" width="80">
                    <template slot-scope="scope">
                        <span style="color:red;">{{scope.row.score}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="使用范围" width="80">
                    <template slot-scope="scope">
                        <div v-if="scope.row.useScope == 1">
                            {{scope.row.className}}
                        </div>
                        <div v-else-if="scope.row.useScope == 2">
                            我的班级
                        </div>
                        <div v-else-if="scope.row.useScope == 3">
                            我的学校
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="orderNum" label="排序号" width="60"></el-table-column>
                <el-table-column label="操作" style="text-align:'left'">
                    <template slot-scope="scope">
                        <el-button  @click.native.prevent="setUpdate(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">修改</span>
                        </el-button>
                        <el-button style="color: red" @click.native.prevent="del(scope.row)"
                            type="text"
                            size="small">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
             <!-- 新增/修改弹出框 -->
            <div v-if="addVisible">
                <add ref="add"></add>
            </div>
            <div v-if="updateVisible">
                <update ref="update"></update>
            </div>
         </div>
    </div>
</template>
 
<script>
    import http from '../../../../../common/http';
    import add from './add.vue';
    import update from './update.vue';

	export default {
         data(){
            return{
                addVisible:false,
                updateVisible:false,
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    id:""
                },
                data:[],
                loading:false,
            }
        },
        created:function () {
            this.getData();
        },
        components: {
            add,update
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            getData(){
                let userId = sessionStorage.getItem('userId');
                let classId = sessionStorage.getItem('classId');
                console.log('待改进：userId-'+userId+"，classId-"+classId);

                //用户管理
                let url  = this.setClassBindEvaluateindexListUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    userId:userId,
                    classId:classId,
                    type:2 // 评价类型（1-表扬，2-待改进）
                };
                this.loading=true;
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data=res.data.list;
                       this.common.total=res.data.total;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });

            },
            //新增界面
            setAdd(){
                this.addVisible=true;
                this.$nextTick(() => {
                    this.$refs['add'].init(this.data,2);
                })
            },
            //修改界面
            setUpdate(data){
                this.updateVisible=true;
                this.$nextTick(() => {
                    this.$refs['update'].init(data);
                })
            },
            //删除
            del(data){
                this.form.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.setClassBindEvaluateindexRemoveUrl;
                let data = {
                    id:this.form.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            }
        },
        mixins: [http]
	}
</script>

<style scoped>
	 
</style>



// WEBPACK FOOTER //
// src/components/page/set/classroomtime/index/improveList.vue